import clsx from 'clsx';
import React from 'react';

import { cn } from '@/src/util/ui';

import { TreatmentForm } from '../../../types/treatment';
import FieldWrapper from '../Fields/FieldWrapper/FieldWrapper';
type ComputationsParams = {
  totals: {
    subTotal: number;
    taxesSubTotal: number;
    total: number;
  };
  readOnly?: boolean;
  className?: string;
  currency: TreatmentForm['currency'];
};

const Computations = ({
  totals,
  currency,
  readOnly = false,
  className = '',
}: ComputationsParams) => {
  const { subTotal, taxesSubTotal, total } = totals;

  return (
    <div
      className={cn(
        'computation--container',
        'tw-flex tw-items-center tw-justify-right tw-flex-wrap',
        readOnly ? 'tw-max-w-[235px]' : 'tw-max-w-[300px]',
        className
      )}
    >
      <FieldWrapper
        containerClassName={cn('tw-mb-[10px]')}
        label={'Subtotal'}
        labelClassName={cn('tw-text-cfo-black')}
        labelWidthClasses={cn('tw-min-w-[110px] tw-max-w-[110px]')}
      >
        <span
          className={clsx(
            'tw-text-cfo-black tw-text-right tw-font-brandonTextMedium',
            'tw-min-w-[100px] tw-w-full'
          )}
        >
          {subTotal}
        </span>
      </FieldWrapper>

      <FieldWrapper
        containerClassName={cn(
          'tw-mb-[10px] tw-pb-[10px]',
          'tw-border-solid tw-border-b-[1px] tw-border-cfo-grey-600'
        )}
        label={'Taxes Subtotal'}
        labelClassName={cn('tw-text-cfo-black')}
        labelWidthClasses={cn('tw-min-w-[110px] tw-max-w-[110px]')}
      >
        <span
          className={clsx(
            'tw-text-cfo-black tw-text-right tw-font-brandonTextMedium',
            'tw-min-w-[100px] tw-w-full'
          )}
        >
          {taxesSubTotal}
        </span>
      </FieldWrapper>

      <FieldWrapper
        containerClassName={cn(
          'tw-mb-[10px]',
          'tw-mb-[10px] tw-pb-[10px]',
          'tw-border-double tw-border-b-[3px] tw-border-cfo-grey-600'
        )}
        label={`Total (in ${currency?.id})`}
        labelClassName={cn('tw-text-cfo-black')}
        labelWidthClasses={cn('tw-min-w-[110px] tw-max-w-[110px]')}
      >
        <span
          className={clsx(
            'tw-text-cfo-black tw-text-right tw-font-brandonTextMedium',
            'tw-min-w-[100px] tw-w-full'
          )}
        >
          {total}
        </span>
      </FieldWrapper>
    </div>
  );
};

export default Computations;
